import { ContentsTableData } from '../../hooks'
import { Designed } from '../../types'

type Props = {
  defaultText?: string
  data: ContentsTableData
}

export const ActiveContentsText = ({
  data: { headings, activeIndex },
  defaultText = '目次',
  ...wrapperProps
}: Designed<Props>) => (
  <div {...wrapperProps}>
    {activeIndex === undefined ||
    headings === undefined ||
    activeIndex >= headings.length ||
    activeIndex < 0 ? (
      <span>{defaultText}</span>
    ) : (
      <span
        dangerouslySetInnerHTML={{
          __html: headings[activeIndex].text,
        }}
      />
    )}
  </div>
)
